import { GetDocumentListTktResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetDocumentListTktModel } from './get-document-list-tkt.state';

/** StateDetailsActions */
const ACTION_SET = '[GetDocumentListTkt] set';
const ACTION_UPDATE = '[GetDocumentListTkt] update';
const ACTION_RESET = '[GetDocumentListTkt] reset';
const ACTION_FAIL = '[GetDocumentListTkt] fail';
const ACTION_CANCEL_REQUEST = '[GetDocumentListTkt] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetDocumentListTkt] set from api';
const ACTION_UPDATE_FROM_API = '[GetDocumentListTkt] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetDocumentListTkt = createAction(ACTION_SET, props<WithRequestId<GetDocumentListTktModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetDocumentListTkt = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetDocumentListTktModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetDocumentListTkt = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetDocumentListTktRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetDocumentListTkt = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetDocumentListTktFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListTktResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetDocumentListTktFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListTktResponse>>()
);
